<template>
	<div class="comp header-bar-comp"
		 :class="{ dark: theme === 'dark', 'is-folded': folded == true }"
		 v-if="!hasOpen">
		<div class="header-bar__wrap left">
			<img src="../assets/images/logo.png"
				 class="logo"
				 alt="友绿"
				 v-show="!hasBack && !noLogo"
				 @click="$router.push('/about')" />
			<img v-if="theme === 'dark'"
				 class="back-img"
				 src="../assets/images/back_white.png"
				 alt="后退"
				 v-show="hasBack"
				 @click="onBack" />
			<img v-else
				 class="back-img"
				 src="../assets/images/back.png"
				 alt="后退"
				 v-show="hasBack"
				 @click="onBack" />
		</div>
		<div class="header-bar__wrap middle">
			<div class="search-input-wrap">
				<form class="search-input-wrap--inner" action="#">
					<input ref="searchIpt"
						   v-show="!!searchPh"
						   v-model="searchString"
						   class="search-input"
						   :placeholder="searchPh"
						   type="search"
						   @keypress="onSearchPress" />
				</form>

				<span v-show="searchString"
					  class="cancel-btn"
					  @click="onSearchClearClick">×</span>
			</div>

			<span class="title"
				  :class="{dark: theme==='dark'}"
				  v-show="!!title">{{ title }}</span>
		</div>
		<div class="header-bar__wrap right">
			<slot></slot>
		</div>
	</div>
	<div class="header-container"
		 v-else>
		<div class="header-left">
			<img src="../assets/images/logo.png"
				 class="logoImg"
				 alt="友绿" />
		</div>
		<div class="header-middle">
			<p class="middle-title">友绿</p>
			<p class="middle-content">绿色地产云智库</p>
		</div>
		<div class="header-right">
			<van-button class="btnImg"
						type="primary"
						@click="openApp">打开App</van-button>
		</div>
	</div>
</template>

<script>
import { getHeaderProps } from '../utils/routerUtil';
import { getOS } from '../utils/storageUtil';
import { isIOS9 ,browser } from '../utils/customerUtil';
import { Button } from 'vant';
import apiUtil from '../utils/apiUtil';
import apiConst from '../consts/apiConst';

export default {
	name: 'headerBar',
	components: {
		'van-button': Button,
	},
	props: {
		titleParam: {
			type: String,
			default: ''
		},
		backFunction: {
			type: Function,
			default: null
		},
		folded: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			path: '',
			hasBack: false,
			noLogo: false,
			searchPh: '',
			title: '',
			theme: '',
			searchString: '',
			hasOpen: (window.location.href.indexOf('openFlag') == -1) ? 0 : 1,
			scheme:'igreen://',
			baseUrl:{
				weixin: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.tencent.mm',
				taobao: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.taobao.taobao',
				mqq: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.tencent.mobileqq',
				TencentWeibo: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.tencent.WBlog',
				igreen:''
			}
		};
	},
	created() {
		const path = this.$route.path;
		this.init(path);
		this.path = path;
		this.getTencentUrl();
	},
	watch: {
		$route(to, from) {
			this.init(to.path);
			this.path = to.path;
		},
		titleParam(val) {
			const route = getHeaderProps(this.path);

			const { title } = route;

			this.title = typeof title === 'function' ? title(val) : title;
		}
	},
	methods: {
		init(path) {
			const route = getHeaderProps(path);
			const { noHeader, hasBack, searchPh, title, theme, noLogo } = route;
			this.noHeader = noHeader || false;
			this.hasBack = hasBack || false;
			this.noLogo = noLogo || false;
			this.searchPh = searchPh || '';
			this.title = typeof title === 'function' ? title(this.titleParam) : title;
			this.theme = theme || '';
		},

		onSearchPress(e) {
			this.searchString = e.target.value;
			if (e.keyCode === 13) {
				this.$emit('search', e.target.value);
				this.$refs.searchIpt.blur()
			}
		},
		async getTencentUrl(){
			const res = await apiUtil.post(apiConst.tencentBao);
			 if (res) {
			 	 const { url } = res;
			 	 this.baseUrl.igreen=url;
			 }
		},
		onSearchClearClick() {
			this.searchString = '';
			this.$refs.searchIpt.blur()
			this.$emit('clear');

		},

		onBack() {
			let url = window.location.href;
			let urlTip = url.substr(url.indexOf('=') + 1)
			if (!!this.backFunction) {
				this.backFunction()
			} else if (urlTip == 1) {
				this.$router.push({
					name: 'discover'
				})
			} else {
				this.$router.go(-1)
			}
		},
		openApp() {
			let _self=this;
			let Os = getOS().os;
			let url = this.scheme;
			let downUrl = "";
			let ua = window.navigator.userAgent.toLowerCase();
			if(browser().isweixin){
				window.location.href = this.baseUrl[_self.scheme.split(':')[0]];
				return false;
			}
			var _loading = function () {
				console.log('正在打开App');
			}
			var $_ifr = $("<iframe src=''></iframe>");
			var t = 3000, ast2 = 100;
			$_ifr.attr("id", "test");
			$_ifr.attr("style", "display:none");
			$("body").append($_ifr);
			$_ifr.attr("src", url);
			if ( browser().ios) {
				window.location.href = url;
			}
			_loading();
			var t1 = new Date().getTime();
			var cc_noapp = true;
			var cc_stop = false;
			var cc_count = 0;
			var tt2, tt1 = t1;
			var cc_check = function () {
				tt2 = new Date().getTime();
				if (tt2 - tt1 > ast2 * 1.3) {
					cc_noapp = false;
					return false;
				}
				tt1 = tt2;
				!cc_stop && setTimeout(cc_check, ast2)
			}
			setTimeout(cc_check, ast2)
			setTimeout(function () {
				cc_stop = true;
				//有APP
				if (new Date().getTime() - t1 > t + 200) {

				}else {
					if (cc_noapp) {
						window.location.href = _self.baseUrl[_self.scheme.split(':')[0]];
					}
					else {

					}
				}
			}, t);
			
		}
	}
};
</script>

<style lang="stylus" scoped>
.header-bar-comp {
	position: sticky;
	top: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	height: 88px;
	padding: 12px 30px;
	background-color: #fff;
	/* border-bottom: 1PX solid #D5D5D5; */
	z-index: 999;
	transition: all .2s linear;
	&.is-folded{
		top: -88px;
	}
	&.dark {
		background-color: #26333C;
		color: #fff;
		border-bottom-color: #26333C;
	}

	.header-bar__wrap {
		display: flex;
		align-items: center;

		&.left {
			flex: 0 0 82px;

			.logo {
				width: 54px;
				height: 54px;
			}

			.back-img {
				width: 24px;
				height: 40px;
			}
		}

		&.middle {
			flex: 1;

			.search-input-wrap {
				width: 100%;
				height: 64px;
				position: relative;

				.cancel-btn {
					position: absolute;
					display: inline-block;
					top: 6px;
					right: 20px;
					color: #666;
					font-size: 48px;
					font-weight: bold;
				}

        .search-input-wrap--inner {
          width: 100%;
					height: 100%;
        }

				.search-input {
					width: 100%;
					height: 100%;
					line-height: 64px;
					padding-left: 86px;
					font-size: 28px;
					color: #999;
					background: url('../assets/images/search.png') 20px center no-repeat #F4F4F4;
					background-size: 28px;
					border-radius: 8px;

					&::-webkit-search-cancel-button {
						display: none;
					}
				}
			}

			.title {
				display: inline-block;
				width: 450px;
				height: 88px;
				line-height: 88px;
				position: absolute;
				left: 50%;
				margin-left: -225px;
				top: 0;
				font-size: 36px;
				color: #333;
				text-align: center;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;

				&.dark {
					color: #fff;
				}
			}
		}

		&.right {
			.fav-img {
				width: 40px;
				height: 40px;
				margin-right: 36px;
			}

			.share-img {
				width: 40px;
				height: 40px;
			}
		}
	}
}

.header-container {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	height: 88px;
	padding: 12px 30px;
	background-color: #fff;
	/* border: 1PX solid red; */
	z-index: 99;

	.header-left {
		display: flex;
		align-items: center;

		.logoImg {
			width: 54px;
			height: 54px;
		}
	}

	.header-middle {
		width: 100%;
		padding-left: 20px;

		.middle-title {
			font-size: 28px;
			font-weight: bold;
			display: block;
			margin-top: 0px;
			margin-bottom: 0px;
		}

		.middle-content {
			font-size: 24px;
			margin-top: 8px;
			margin-bottom: 0px;
		}
	}

	.header-right {
		/* width:100%; */
		.btnImg {
			width: 140px;
			height: 54px;
			font-size: 23px;
			text-align: center;
			line-height: 20px;
			border-radius: 25px 25px;
		}
	}
}
</style>
